module.exports = __webpack_public_path__ + "static/img/274_TO8_2399.f71e208.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/274_TO8_2399.jpg
// module id = 3gUt
// module chunks = 0